import { render, staticRenderFns } from "./OrdersSummary.vue?vue&type=template&id=323ca1d8&scoped=true"
import script from "./OrdersSummary.vue?vue&type=script&lang=ts"
export * from "./OrdersSummary.vue?vue&type=script&lang=ts"
import style0 from "./OrdersSummary.vue?vue&type=style&index=0&id=323ca1d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "323ca1d8",
  null
  
)

export default component.exports